import type { PayerBank } from '../models/BankAccount';

/** Nombre del banco pagador: API embebida, catálogo cargado o fallback #id */
export const resolvePayerBankName = (
  payerBankId: number,
  payerBank: Pick<PayerBank, 'name'> | null | undefined,
  nameById: ReadonlyMap<number, string>,
): string => payerBank?.name ?? nameById.get(payerBankId) ?? `#${payerBankId}`;

export const buildPayerBankNameById = (banks: PayerBank[]): Map<number, string> => {
  const map = new Map<number, string>();
  banks.forEach((bank) => map.set(bank.id, bank.name));
  return map;
};
